import { useState, useCallback, useEffect } from 'react';

import { utagViewArtificialPageView } from 'features/tealium';

const trackArtificalPageViewEvent = utagViewArtificialPageView();

const back = (pushStateHash, hashchangeHandler) => {

	if (pushStateHash) {

		window.removeEventListener('hashchange', hashchangeHandler);
		window.history.back();

	}

};

function useOverlayState (initiallyShown = false, pushStateHash = '') {

	const [ show, setShow ] = useState(initiallyShown);

	const hideOverlay = useCallback(
		(skipHistoryBack) => {

			trackArtificalPageViewEvent({ pageName: '' });
			setShow(false);
			if (!skipHistoryBack) {

				back(pushStateHash, hashchangeHandler);

			}

		},
		[]
	);

	const hashchangeHandler = useCallback(
		(e) => {

			const { oldURL } = e;
			const oldURLHash = new URL(oldURL).hash;
			if (oldURLHash === pushStateHash) {

				hideOverlay(true);
				window.removeEventListener('hashchange', hashchangeHandler);

			}

		},
		[]
	);

	const pushState = useCallback(() => {

		if (pushStateHash) {

			const currentHash = window.location.hash;
			if (!currentHash || currentHash !== pushStateHash) {

				window.history.pushState(null, '', pushStateHash);

			}
			window.addEventListener('hashchange', hashchangeHandler);

		}

	}, []);

	const showOverlay = useCallback(() => {

		setShow(true);
		pushState();

	}, []);

	const toggleOverlay = useCallback(() => {

		if (show) {

			hideOverlay();

		} else {

			showOverlay();

		}

	}, [ show ]);

	useEffect(() => {

		if (show) {

			pushState();

		}

	}, [ show ]);

	return {
		show,
		showOverlay,
		hideOverlay,
		toggleOverlay
	};

}

export default useOverlayState;
